import React, { ReactElement } from 'react';
import styles from './linkExpiredPage.module.scss';
import { Title } from '../../../components/title/Title';
import { LoadableButton } from '@mo/loadable-button';
import { useHistory } from 'react-router-dom';
import { FORGOT_PASSWORD_PAGE } from '../../../common/routes';

const LinkExpiredPage: React.FunctionComponent = (): ReactElement | null => {
    const history = useHistory();
    const buttonText = 'Reset your password';
    return (
        <div className={styles.gridContainer}>
            <div className={styles.page}>
                <div className={styles.form}>
                    <div className={styles.formHeader}>
                        <div className={styles.formHeaderContent}>
                            <Title title='This link has expired' />
                        </div>
                    </div>
                    <p>Your secure password reset link expired after 2 hours or has already been used.</p>
                    <p>You can reset your password again below if required.</p>
                    <LoadableButton
                        loading={false}
                        loadingText={buttonText}
                        notLoadingText={buttonText}
                        onClick={(): void => history.push(FORGOT_PASSWORD_PAGE)}
                        className={styles.forgotPasswordButton}
                    />
                </div>
            </div>
        </div>
    );
};

export default LinkExpiredPage;
